/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListOrderBooksOptions,
  ListOrderBooksStatus200,
  ListOrderBooksStatus400,
  ListOrderBooksStatus404,
  ListOrderBooksStatus500,
} from '../types/ListOrderBooks'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listOrderBooks } from '../clients/listOrderBooks'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listOrderBooksQueryKey = ({ query }: Omit<ListOrderBooksOptions, 'headers'> = {}) =>
  [{ url: '/v1/orderbooks' }, ...(query ? [query] : [])] as const

type ListOrderBooksQueryKey = ReturnType<typeof listOrderBooksQueryKey>

export function listOrderBooksQueryOptions(
  { query }: ListOrderBooksOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listOrderBooksQueryKey({ query })
  return queryOptions<
    ListOrderBooksStatus200,
    ResponseErrorConfig<
      ListOrderBooksStatus400 | ListOrderBooksStatus404 | ListOrderBooksStatus500
    >,
    ListOrderBooksStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listOrderBooks({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary List order books
 * {@link /v1/orderbooks}
 */
export function useListOrderBooks<
  TData = ListOrderBooksStatus200,
  TQueryData = ListOrderBooksStatus200,
  TQueryKey extends QueryKey = ListOrderBooksQueryKey,
>(
  {
    query,
  }: { query?: ListOrderBooksOptions['query'] | (() => ListOrderBooksOptions['query']) } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListOrderBooksStatus200,
        ResponseErrorConfig<
          ListOrderBooksStatus400 | ListOrderBooksStatus404 | ListOrderBooksStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listOrderBooksQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listOrderBooksQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<ListOrderBooksStatus400 | ListOrderBooksStatus404 | ListOrderBooksStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
